import { makeAuthClient } from "../factories/auth-client/auth-client-factory";
var authClientInstance;
export var getAuthClientInstance = function () {
    if (!authClientInstance)
        authClientInstance = makeAuthClient();
    return authClientInstance;
};
